export enum InstallationTypeEnum {
    Unknown = -1,
    BackOffice = 0,
    FrontOffice = 1,
}

export function installationTypeEnumLabel(value: InstallationTypeEnum): string {
    switch (value) {
        case InstallationTypeEnum.BackOffice:
            return "enum.installationType.backOffice";
        case InstallationTypeEnum.FrontOffice:
            return "enum.installationType.frontOffice";
        default:
            return "common.unknown";
    }
}